export default "__VITE_ASSET__BL8Rbi1a__"